import { WholesaleService } from '../services/wholesale.service';

export class UrlUtilityHelpers {}

export function setPrefixUrl(wholesaleService: WholesaleService): string {
    const slug = wholesaleService.getSupplierSlug();
    return '/' + (slug ? slug : '');
}
